export class PerformanceState {
	public includeFee?: boolean;
	public customAdvisoryFee: number;
	public selectedBenchmarkForCaptureRatio: string;
	public hypotheticalGrowthStartTimestamp?: number;
	public hypotheticalGrowthMultiplier: number = 10000;
}
